// src/components/common/Pagination/Pagination.js
//common pagination file
import React from 'react';

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  maxVisiblePages = 5,
  showPageInfo = false,
  totalItems = 0,
  pageSize = 10,
  className = '',
  style = {}
}) => {
  const pageNumbers = [];
  const halfVisible = Math.floor(maxVisiblePages / 2);

  if (!totalPages || totalPages <= 0) return null;

  let startPage = Math.max(1, currentPage - halfVisible);
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
  
  if (endPage - startPage + 1 < maxVisiblePages) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  // Add first page with ellipsis if needed
  if (startPage > 1) {
    pageNumbers.push(
      <li key={1} className="page-item">
        <button className="page-link" onClick={() => onPageChange(1)}>
          1
        </button>
      </li>
    );
    if (startPage > 2) {
      pageNumbers.push(
        <li key="ellipsis-start" className="page-item disabled">
          <span className="page-link">…</span>
        </li>
      );
    }
  }

  // Add visible page numbers
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(
      <li
        key={i}
        className={`page-item ${currentPage === i ? "active" : ""}`}
      >
        <button className="page-link" onClick={() => onPageChange(i)}>
          {i}
        </button>
      </li>
    );
  }

  // Add last page with ellipsis if needed
  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      pageNumbers.push(
        <li key="ellipsis-end" className="page-item disabled">
          <span className="page-link">…</span>
        </li>
      );
    }
    pageNumbers.push(
      <li key={totalPages} className="page-item">
        <button className="page-link" onClick={() => onPageChange(totalPages)}>
          {totalPages}
        </button>
      </li>
    );
  }

  const paginationContent = (
    <nav aria-label="Pagination" className={className}>
      <ul className="pagination" style={{ 
        flexWrap: 'wrap', 
        marginBottom: 0,
        gap: '5px',
        justifyContent: 'center',
        ...style
      }}>
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(currentPage - 1)}
          >
            Previous
          </button>
        </li>
        {pageNumbers}
        <li
          className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => onPageChange(currentPage + 1)}
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );

  if (showPageInfo) {
    return (
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div style={{ fontSize: '14px', color: '#6c757d' }}>
          {totalItems > 0 ? (
            <>
              Showing {(currentPage - 1) * pageSize + 1} -{' '}
              {Math.min(currentPage * pageSize, totalItems)} of {totalItems} items
            </>
          ) : (
            'No items to display'
          )}
        </div>
        {paginationContent}
      </div>
    );
  }

  return paginationContent;
};

export default Pagination;